import { useMemo } from 'react';
import { Screen, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '~/commonComponents';
import { BackButton } from '~/commonComponents/BackButton';
import { fireHelpAboutClicked, fireHelpHowItWorksClicked } from '~/posthogs/events';
import { routes } from '~/routes';
import { NumberUtils } from '~/utils/NumberUtils';
import { HelpMenuLink } from './HelpMenuLink';
import { HelpSection } from './HelpSection';

export const HelpScreen = () => {
  const csPhoneNumber = useMemo(() => NumberUtils.getCSPhone(), []);

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="Help Center" />
      <Screen.Body>
        <Box
          backgroundColor={colors.neutral[50]}
          flex={1}
          marginHorizontal={56}
          paddingBottom={80}
          paddingHorizontal={40}
          paddingTop={40}
          width="auto"
          gap={12}
          marginBottom={60}
        >
          <HelpSection title="About GoTu">
            <HelpMenuLink href={routes.about} text="About" onClick={fireHelpAboutClicked} />
            <HelpMenuLink href={routes.howItWorks} text="How it Works" onClick={fireHelpHowItWorksClicked} />
          </HelpSection>

          <HelpSection title="Contact Us">
            <Typography as="span" variant="body1">
              Customer Service Text/Call:
              <Typography as="span" bold variant="body1">{` ${csPhoneNumber.formatted}`}</Typography>
            </Typography>
          </HelpSection>
        </Box>
      </Screen.Body>
    </Screen>
  );
};
